/**
 * Readings over time as points, for the graph tile (drawn by Chart.js, docs/specs/graph-tile.md)
 * and the sparkline.
 */

export interface GraphPoint {
    /** Milliseconds since the Unix epoch. */
    time: number;
    value: number;
}

/** The running total of a series (legacy `cumulative`). */
export function cumulativePoints(points: readonly GraphPoint[]) : GraphPoint[] {
    let total = 0;

    return points.map((point) => {
        total += point.value;

        return { time: point.time, value: total };
    });
}
